<template src='./tabIntegrations.pug' lang='pug'></template>

<script>
import moment from 'moment'
import LoadingPlaceholder from '../../../loading/LoadingPlaceholder'
import language from '../../../../../build/language/index'
import { generateLoadingRows } from '../../../../utils/grid-load-transition.js'
import { originTranslate } from '../../../../utils/statusesTranslator.js'

moment.locale(language.getDatePickerLanguage())

export default {
  name: 'TabIntegrations',

  components: {
    LoadingPlaceholder
  },

  props: {
    idModal: {
      type: String
    },
    idProcessamento: {
      type: Number,
      required: true,
      default: -1
    },
    establishtmentValue: {
      type: Object
    },
    integrationValuesList: {
      type: Array,
      required: true
    },
    loadIntegration: {
      type: Function
    }
  },

  data () {
    return {
      columns: ['id', 'arquivo', 'sequencia', 'dtgen', 'layout', 'origem', 'dtproc'],
      options: {
        columnsClasses: {
          'id': 'table-col-1',
          'arquivo': 'table-col-2',
          'sequencia': 'table-col-1',
          'dtgen': 'table-col-1',
          'layout': 'table-col-2',
          'origem': 'table-col-1',
          'dtproc': 'table-col-1'
        },
        headings: {
          id: this.$t('modalDetalhesLanc.tabItegrations.labels.idProc'),
          arquivo: this.$t('modalDetalhesLanc.tabItegrations.labels.arquivo'),
          sequencia: this.$t('modalDetalhesLanc.tabItegrations.labels.sequencia'),
          dtgen: this.$t('modalDetalhesLanc.tabItegrations.labels.dtgen'),
          layout: this.$t('modalDetalhesLanc.tabItegrations.labels.layout'),
          origem: this.$t('modalDetalhesLanc.tabItegrations.labels.origem'),
          dtproc: this.$t('modalDetalhesLanc.tabItegrations.labels.dtproc')
        },
        templates: {
          id: LoadingPlaceholder,
          arquivo: LoadingPlaceholder,
          sequencia: LoadingPlaceholder,
          dtgen: LoadingPlaceholder,
          layout: LoadingPlaceholder,
          origem: LoadingPlaceholder,
          dtproc: LoadingPlaceholder
        },
        filterable: false,
        perPageValues: [],
        texts: {
          count: this.$t('dataTable.labels.contagem'),
          noResults: this.$t('dataTable.labels.semResultados'),
          filter: null,
          filterPlaceholder: null
        },
        pagination: {},
        sortable: ['id'],
        sortIcon: {
          is: ''
        }
      },
      processedFiles: generateLoadingRows(3)
    }
  },

  methods: {
    closeModal () {
      $('#' + this.idModal).modal('hide')
    },
    getStatusValueClass (item) {
      let title = ''
      switch (item.value) {
        case 'C':
          title = 'detail-status-C'
          break
        case 'M':
          title = 'detail-status-C'
          break
        case 'D':
          title = 'detail-status-D'
          break
        case 'N':
          title = 'detail-status-N'
          break
        case 'A':
          title = 'detail-status-A'
          break
        default :
          title = 'detail-value'
          break
      }
      return title
    },

    getStatusValueLabel (item) {
      let title = ''
      switch (item.value) {
        case 'C':
          title = this.$t('statusConciliacao.conciliado')
          break
        case 'M':
          title = this.$t('statusConciliacao.conciliadoManualmente')
          break
        case 'D':
          title = this.$t('statusConciliacao.divergente')
          break
        case 'N':
          title = this.$t('statusConciliacao.naoAplicavel')
          break
        case 'A':
          title = this.$t('statusConciliacao.aberto')
          break
        default :
          title = item.value
          break
      }
      return title
    },

    loadProcFile () {
      if (this.idProcessamento && this.idProcessamento >= 0) {
        this.loadIntegration(this.idProcessamento).then((response) => {
          this.processedFiles = []
          this.processedFiles.push({
            id: response.id,
            arquivo: response.nomeArquivo ? response.nomeArquivo : ' - ',
            sequencia: response.numSequencia ? response.numSequencia : ' - ',
            dtgen: response.dataGeracao ? moment(response.dataGeracao).format('DD/MM/YYYY') : ' - ',
            layout: response.layout ? response.layout : ' - ',
            origem: response.origem ? originTranslate(response.origem, this) : ' - ',
            dtproc: response.dataFinal ? moment(response.dataFinal).format('DD/MM/YYYY') : ' - '
          })
          this.options.templates = {}
        }).catch((error) => {
          this.processedFiles = []
          this.$root.$refs.notification.error(error.message)
        })
      } else {
        this.processedFiles = []
        this.options.templates = {}
      }
    }
  }
}
</script>

<style lang='css'>
.grid-modal-content {
  padding: 5px 10px 0px 10px;
  min-height: 47vh;
  min-width: 47vw;
}

.detail-value {
  font-family: 'Inter', sans-serif;
  font-weight: bold;
  color: #17375f;
  font-size: 15px;
}

.detail-title {
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  margin-top: 1vh;
  color: #17375f;
}

#tab-integrations-id.modal-footer {
  padding: 0px;
}

#main-integrations-container.main-container {
  max-height: 50vh;
  overflow: auto;
}

.modal-data-table {
  max-width: 47vw;
}

.font-C {
  color: #3bb57a;
}

.font-D {
  color: #f55753;
}

.font-N {
  color: #56a9c1;
}

.font-A {
  color: #fdbd39;
}

.table-col-1 {
  min-width: 9vw;
  font-size: 12px;
  text-align: initial;
}

.table-col-2 {
  min-width: 15vw;
  font-size: 12px;
  text-align: initial;
}

#tab-integrations-id {
  margin: 0px;
  overflow: hidden;
  width: 100%;
  font-family: 'Inter', sans-serif;
}

#monetary-container {
  margin: 5px 10px;
}
</style>



// WEBPACK FOOTER //
// TabIntegrations.vue?6de99587